import { $, _, Backbone, Radio, Foundation, moment } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import InboomaBaseCollectionView from "../InboomaBaseCollectionView";
import { Notification, Biscuit } from "../../utils";
import { parseUrlIntoObject } from "../../utils/Uri";
import { Uri } from "../../utils";
import "../../../vendor/Blob";
import { getApiHost } from "../../Sync";
import PaginationBehavior from "../../behaviors/Behavior.Pagination";
import { getContentModifications } from "../../App";

import ReservationsItemTpl from "../../templates/reservationsList/ReservationsItemTpl.html";

const ReservationsItemView = InboomaBaseView.extend({
  template: ReservationsItemTpl,
  className: "inb-c-item inb-c-item--order inb-c-item-reservation row", // keep class inb-c-item--order for now

  ui: {
    infoTooltip: ".fi-info",
    dropdown: ".inb-dropdown",
    reservationEdit: ".inb-order__edit",
    reservationCancel: ".inb-reservation .inb-reservation__cancel",
  },

  events: {
    "change .inb-order--status .inb-status-select": "_reservationStatusChanged",
    "click @ui.reservationCancel": "_cancelReservation",
    "click .inb-toggle-order-dd": "_initDropdown",
    "click .inb-reservation__pdf2": "_printRentalContract",
  },

  modelEvents: {
    changed: "render",
    destroy: "remove", // maybe we need to handle this
    "change:status": "_statusChanged",
  },

  templateContext() {
    return {
      _,
      moment,
      t: this.t,
      Biscuit,
      begin:
        this.model.get("begin") !== "" ? moment(this.model.get("begin")) : "",
      end: this.model.get("end") !== "" ? moment(this.model.get("end")) : "",
      app_user_role: Biscuit.get("user.role"),
      locations: this.options.locations,
      // Temporarily only:
      has_checkin: this.model.get("status") == "inprogress",
      // Temporarily only:
      has_checkout: this.model.get("status") == "completed",
      first_usage: this.model.get("first_usage"),
      getOrderNumber: () => {
        if (
          typeof this.model.get("order") != "undefined" &&
          this.model.get("order") != null
        ) {
          return this.model.get("order").order_nbr;
        }
        return "-";
      },
      getOrderUsername: () => {
        if (
          typeof this.model.get("order") !== "undefined" &&
          this.model.get("order") !== null
        ) {
          if (
            typeof this.model.get("order").user === "undefined" ||
            this.model.get("order").user === null
          ) {
            return this.t("customer_removed");
          } else {
            const user = this.model.get("order").user;
            if (
              (user.first_name === undefined ||
                user.first_name == null ||
                user.first_name == "") &&
              (user.last_name === undefined ||
                user.last_name == null ||
                user.last_name == "")
            ) {
              return user.customer_nbr;
            }
            return (
              this.model.get("order").user.first_name +
              " " +
              this.model.get("order").user.last_name
            );
          }
        }
      },
      getOrderUserLink: () => {
        if (
          typeof this.model.get("order") !== "undefined" &&
          this.model.get("order") !== null
        ) {
          if (
            typeof this.model.get("order").user === "undefined" ||
            this.model.get("order").user === null
          ) {
            return "#";
          } else {
            return "users/" + this.model.get("order").user.id;
          }
        }
      },
      printContingentsAmountList: this.model.printContingentsAmountList(
        "",
        this.model,
      ),
      getBeginLocationName: () => {
        let begin_location_id =
          this.model.get("location_id") === null
            ? this.model.get("begin_location")
            : this.model.get("location_id");

        if (begin_location_id !== null) {
          let locations = this.options.locations;

          if (typeof locations.get(begin_location_id) !== "undefined") {
            return locations.get(begin_location_id).get("name");
          } else {
            console.log(
              "ReservationsView: Error: Can't resolve location with ID: " +
                begin_location_id,
            );
          }
        }

        return "";
      },
      getEndLocationName: () => {
        let end_location_id =
          this.model.get("location_id") === null
            ? this.model.get("end_location")
            : this.model.get("location_id");

        if (end_location_id !== null) {
          let locations = this.options.locations;

          if (typeof locations.get(end_location_id) !== "undefined") {
            return locations.get(end_location_id).get("name");
          } else {
            console.log(
              "ReservationsView: Error: Can't resolve location with ID: " +
                end_location_id,
            );
          }
        }

        return "";
      },
      getCheckinLocationName: () => {
        let checkins = this.model.get("checkins");
        let checkin_location_id =
          checkins !== undefined && checkins.length > 0
            ? checkins[0].location_checkin
            : null;

        if (checkin_location_id !== null) {
          let locations = this.options.locations;

          if (typeof locations.get(checkin_location_id) !== "undefined") {
            return locations.get(checkin_location_id).get("name");
          } else {
            console.log(
              "ReservationsView: Error: Can't resolve checkin location with ID: " +
                checkin_location_id,
            );
          }
        }

        return "";
      },
      getCheckoutLocationName: () => {
        let checkins = this.model.get("checkins");
        let checkout_location_id =
          checkins !== undefined && checkins.length > 0
            ? checkins[0].location_checkout
            : null;

        if (checkout_location_id !== null) {
          let locations = this.options.locations;

          if (typeof locations.get(checkout_location_id) !== "undefined") {
            return locations.get(checkout_location_id).get("name");
          } else {
            console.log(
              "ReservationsView: Error: Can't resolve checkout location with ID: " +
                checkout_location_id,
            );
          }
        }

        return "";
      },
      getPayStatus: () => {
        if (
          typeof this.model.get("order") !== "undefined" &&
          this.model.get("order") !== null
        ) {
          if (this.model.get("order").status !== "paid") {
            if (this.model.get("order").price > 0) {
              return this.t("open");
            } else {
              return "";
            }
          } else {
            return this.t("paid");
          }
          if (
            typeof this.model.get("order").paid === "undefined" ||
            this.model.get("order").paid === null ||
            this.model.get("order").paid === 0
          ) {
            if (this.model.get("order").price > 0) {
              return this.t("open");
            } else {
              return "";
            }
          } else {
            return this.t("paid");
          }
        }
      },
      getLieferOrt: () => {
        let Lieferaddresse = "";
        if (
          typeof this.model.get("order") !== "undefined" &&
          this.model.get("order") !== null
        ) {
          if (typeof this.model.get("order").order_addresses !== "undefined") {
            _.each(
              this.model.get("order").order_addresses,
              function (value, key) {
                if (value.type === "begin") {
                  Lieferaddresse =
                    value.street + " " + value.number + ", " + value.city;
                }
              },
            );
          }
        }
        return Lieferaddresse;
      },
      getAbholOrt: () => {
        let Abholaddresse = "";
        if (
          typeof this.model.get("order") !== "undefined" &&
          this.model.get("order") !== null
        ) {
          if (typeof this.model.get("order").order_addresses !== "undefined") {
            _.each(
              this.model.get("order").order_addresses,
              function (value, key) {
                if (value.type === "end") {
                  Abholaddresse =
                    value.street + " " + value.number + ", " + value.city;
                }
              },
            );
          }
        }
        return Abholaddresse;
      },
      tooltipInlay: () => {
        let doku = "";
        if (
          typeof this.model.get("order") !== "undefined" &&
          this.model.get("order") !== null
        ) {
          if (typeof this.model.get("order").tag_list !== "undefined") {
            let tags = this.model.get("order").tag_list.split(",");
            _.each(tags, function (val, k) {
              if (val.trim() === "Anlieferungen") {
                doku = "anlieferungen";
              }
              if (val.trim() === "Tour") {
                doku = "touren";
              }
            });
          }
        }
        if (this.model.get("types") === "service") {
          doku = "service";
        }
        return doku;
      },
      getTagClasses: () => {},
      _exchangeLabel: (value) => {
        let cm = getContentModifications();

        if (cm.labels != null) {
          if (cm.labels[value] !== undefined) {
            return cm.labels[value];
          }
        }
        return value;
      },
      isHiddenElement: (id) => {
        let cm = getContentModifications();

        if (cm.hidden_elements != null && cm.hidden_elements.length > 0) {
          for (var i = 0; i < cm.hidden_elements.length; i++) {
            if (cm.hidden_elements[i] == id) return true;
          }
        }
        return false;
      },
    };
  },

  onBeforeRender() {
    if (this.options.toggleOrderById == this.model.get("id")) {
      this._renderToggled = true;
      this.$el.addClass("toggled");
    }

    if (this.model.get("status") == "cancelled") {
      this.$el.addClass("is-cancelled");
    }
    let hasFormData = false,
      hasTour = false;
    if (
      typeof this.model.get("order") !== "undefined" &&
      this.model.get("order") !== null
    ) {
      if (typeof this.model.get("order").tag_list !== "undefined") {
        let tags = this.model.get("order").tag_list.split(",");
        _.each(tags, function (val, k) {
          if (val.trim() === "Anlieferungen") {
            hasFormData = true;
          }
          if (val.trim() === "Tour") {
            hasTour = true;
          }
        });
      }
    }
    const that = this;

    if (
      hasFormData &&
      (this.model.get("status") === "confirmed" ||
        this.model.get("status") === "paid")
    ) {
      this.$el.addClass("has-form-data");
    } else if (hasFormData && this.model.get("status") === "requested") {
      this.$el.addClass("has-form-data-requested");
    } else {
      this.$el.addClass("has-no-form-data");
    }

    if (hasTour) {
      this.$el.addClass("has-tour");
    } else {
      this.$el.addClass("has-no-tour");
    }

    if (this.model.get("types") === "service") {
      this.$el.addClass("is-service");
    } else {
      this.$el.addClass("is-no-service");
    }
  },

  onRender() {
    let tooltip = this.getUI("infoTooltip");
    if (tooltip.length) {
      new Foundation.Tooltip(tooltip);
    }
  },

  _statusChanged() {
    // If new status has any effects on child reservations...
    const status = this.model.get("status");

    this.$el.removeClass("is-cancelled");

    switch (status) {
      case "cancelled":
        this.$el.addClass("is-cancelled");

        // Manually unset reservation-status as API
        // does not return orders.reservations on patch
        this.model.set(
          {
            status: "cancelled",
            checkins: [],
          },
          { silent: true },
        );

        new Notification({
          message: this.t("reservation") + " " + this.t("cancelled"),
          duration: 9000,
          type: "success",
          closeable: true,
          icon: "fi fi-loop",
        });

        break;
    }

    this.render();
  },

  _initDropdown(ev) {
    ev.preventDefault();

    this._dropdown = new Foundation.Dropdown(this.getUI("dropdown"));
    this._dropdown.open();

    return false;
  },

  _reservationStatusChanged(target) {
    const that = this,
      t = $(target.currentTarget),
      val = t.val();

    if (val !== "") {
      this.model.save(
        { status: val },
        {
          patch: true,
          success: () => {
            new Notification({
              message: that.t(
                "updated_${a}",
                { a: that.t("reservation") },
                "capital",
              ),
              duration: 5000,
              type: "success",
              closeable: true,
              icon: "fi fi-check",
            });

            that.render();
          },
        },
      );
    }
  },

  _printRentalContract(target) {
    const ref = getApiHost().slice(0, -4) + "/rental_contract/" + this.model.id;
    window.open(ref, "_blank");
  },
});

export default InboomaBaseCollectionView.extend({
  childView: ReservationsItemView,
  template: _.noop,

  childViewOptions() {
    return {
      toggleReservationById: this.getOption("toggleId"),
      locations: this._locations,
    };
  },

  behaviors: [
    {
      behaviorClass: PaginationBehavior,
    },
  ],

  _onCollectionChange(obj) {
    // View should be rendered if a model has been changed somehow
    if (
      typeof obj.changed !== "undefined" &&
      typeof obj.changed.order !== "undefined"
    ) {
      this.render();
    }
  },

  initialize() {
    this.collection.on("change", this._onCollectionChange.bind(this));

    // Init utils here once and pass down to model templates
    this._locations = Radio.channel("locationsWithTrashed").request("get:data");

    InboomaBaseCollectionView.prototype.initialize.apply(this);

    if (!this.options.widgetMode) {
      this.$el.html("");
    }

    if (document.getElementById("inb-c-main-sort-nav") != null) {
      document.getElementById("inb-c-main-sort-nav").classList.remove("hide");
    }

    if (Uri.getUrlParameter("reservation_id")) {
      const that = this;
      const RequestHelper = Backbone.Model.extend({
        urlRoot: "/reservations/" + Uri.getUrlParameter("reservation_id"),
      });

      new RequestHelper(null).fetch({
        success(model, response) {
          if (response.success && response.data.id != undefined) {
            that.collection.reset();
            that.collection.add(response.data);
          } else {
            console.log("ERROR: failed to get reservation");
          }
        },
        error(model, response) {
          console.log("Error, could not request reservation.");
        },
      });
    }

    this.render();
  },

  removeEventListener() {
    this.collection.off("change", this._onCollectionChange);
  },

  onRender() {
    if ($(".inb-c-item.toggled").length >= 1) {
      $("html,body").scrollTop($(".inb-c-item.toggled").offset().top - 10);
    }
    /*
        let searchBar = document.getElementsByClassName('inb-input--search')[0];
        if (searchBar.value.length == 0 && Uri.getUrlParameter('order_id')) {
            searchBar.value = Uri.getUrlParameter('order_id');
            $(searchBar).trigger('keyup');
        }*/
  },
});
